<template>
    <div v-if="!nonStyle" :class="(horizontal) ? 'fab-buttons' : 'fab-buttons-horizontal'">
        <v-btn x-small fab color="white" :class="(horizontal) ? 'mb-3' : 'mr-2'"
            @click="goTo('https://www.facebook.com/cajapsipba/')">
            <v-icon color="grey darken-3">fab fa-facebook-f</v-icon>
        </v-btn>
        <v-btn x-small fab color="white" :class="(horizontal) ? 'mb-3' : 'mr-2'"
            @click="goTo('https://www.instagram.com/caja.de.psicologos.pcia.bs.as/')">
            <v-icon color="grey darken-3">
                fab fa-instagram
            </v-icon>
        </v-btn>
        <v-btn x-small fab color="white" @click="goTo('https://www.youtube.com/channel/UCja3uUSi79UkfN1c8_x__Eg')">
            <v-icon color="grey darken-3">fab fa-youtube</v-icon>
        </v-btn>
    </div>
    <div v-else>
        <v-btn small fab color="primary" class="mr-2" @click="goTo('https://www.facebook.com/cajapsipba/')">
            <v-icon dark>fab fa-facebook-f</v-icon>
        </v-btn>
        <v-btn small fab color="primary" :class="(horizontal) ? 'mb-3' : 'mr-2'"
            @click="goTo('https://www.instagram.com/caja.de.psicologos.pcia.bs.as/')">
            <v-icon dark>
                fab fa-instagram
            </v-icon>
        </v-btn>
        <v-btn small fab color="primary" @click="goTo('https://www.youtube.com/channel/UCja3uUSi79UkfN1c8_x__Eg')">
            <v-icon dark>fab fa-youtube</v-icon>
        </v-btn>
    </div>
</template>

<script>

export default {
    name: "FabRedesSociales",
    data() {
        return {

        }
    },
    methods: {
        goTo(url) {
            window.open(url, "_blank")
        }
    },

    props: {
        nonStyle: {
            type: Boolean,
            default: false,
            required: false
        },
        horizontal: {
            type: Boolean,
            default: false,
            required: false
        }
    }
};
</script>


<style>
.fab-buttons {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 16px;
    left: 28px;
}


.fab-buttons-horizontal {
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 16px;
    right: 28px;
}
</style>